declare namespace $ {

	type $mol_search__query_bog_wikilive_search_1 = $mol_type_enforce<
		ReturnType< $bog_wikilive_search['query'] >
		,
		ReturnType< $mol_search['query'] >
	>
	type $mol_list__rows_bog_wikilive_search_2 = $mol_type_enforce<
		ReturnType< $bog_wikilive_search['result_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_wikilive_search_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_bog_wikilive_search_4 = $mol_type_enforce<
		ReturnType< $bog_wikilive_search['result_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_wikilive_search_5 = $mol_type_enforce<
		ReturnType< $bog_wikilive_search['result_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $bog_wikilive_search extends $mol_page {
		query( next?: string ): string
		Search( ): $mol_search
		result_rows( ): readonly(any)[]
		Results( ): $mol_list
		empty_text( ): string
		Empty( ): $mol_view
		result_title( id: any): string
		result_click( id: any, next?: any ): any
		store( ): $bog_wikilive_store
		page_selected( next?: string ): string
		title( ): string
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
		Result_row( id: any): $mol_button_minor
	}
	
}

//# sourceMappingURL=search.view.tree.d.ts.map